import {getReportParams, report} from '../../../middleware/report';

export function dwhExtendedLead(status,messageText, isAgreementsCheckBoxActive,leadSubject, firstName ,lastName,identity ,payment,phoneNumber,emailAddress ) {
  let reportParams = getReportParams();
  reportParams.subscriber = phoneNumber,
  reportParams.area = 'MarketingPages';
  reportParams.subArea = 'LeadBlocks';
  reportParams.channel = 'WebsitePrivate';
  reportParams.actionType = 'Extended Lead Block';
  reportParams.status = status;
  reportParams.messageText = messageText;
  reportParams.param1 = isAgreementsCheckBoxActive;
  reportParams.param2 = leadSubject;
  reportParams.param3 = firstName;
  reportParams.param4 = lastName;
  reportParams.param5 = identity;
  reportParams.param6 = payment;
  reportParams.param7 = phoneNumber;
  reportParams.param8 = emailAddress;
  report(reportParams);
}
